<div class="modal-header">
    <h4 class="modal-title" id="mondalAddCampaignTitle">Artes Fuente: <strong>{{ data.strategy.name }}</strong></h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
        <h6>
            <mat-icon class="align-middle">sell</mat-icon> Folio: <strong>{{ data.strategy.invoice }}</strong>
            <span *ngIf="artFiles"> 
                <mat-icon class="align-middle ms-4">update</mat-icon> 
                Última actualización: <strong>{{ artFiles[0].created_at | date : "dd/MM/yyyy hh:mma": "-0000" }} {{ " - " + artFiles[0].user }}  </strong>
            </span>
        </h6>
        <h6 class="pb-4">
            <span class="align-middle">Lista de Archivos Artes Fuente</span>
            <div class="float-end align-middle">
                <a *ngIf="artFiles" href="{{artFiles[0].url}}" target="_blank" mat-stroked-button color="primary">Descarga último archivo <mat-icon class="align-middle ms-1">file_download</mat-icon></a>
                <button *ngIf="canUploadArt" class="ms-4" mat-flat-button color="primary" (click)="openDialogArtUploadFile()">Subir archivo
                    <mat-icon>upload_file</mat-icon>
                </button>
            </div>
        </h6>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <mat-divider></mat-divider>
        <div>
            <div class="row g-2">
                <div class="col mb-0">
                    <div class="table-responsive text-nowrap">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Archivo</th>
                                    <th>Subió</th>
                                    <th>Fecha de Registro</th>
                                    <th>Equipo</th>
                                </tr>
                            </thead>
                            <tbody class="table-border-bottom-0">
                                <tr *ngFor="let af of artFiles">
                                    <td>
                                        {{af.id}}
                                    </td>
                                    <td>
                                        <a href="{{af.url}}" target="_blank">{{af.name}}</a>
                                    </td>
                                    <td>
                                        {{af.user}}
                                    </td>
                                    <td>
                                        {{af.created_at | date : "dd/MM/yyyy hh:mma": "-0000"}}
                                    </td>
                                    <td>
                                        <span class="badge {{af.id_rol==3?'bg-info':'bg-warning'}}">{{af.rol}}</span>
                                    </td>
                                </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>